export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_12.49df308e.jpg";